import React from 'react';
import { useAuth } from '../auth/auth_context';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { isAuthReady, token } = useAuth();

  if (!isAuthReady) {
    return <div>Loading...</div>;
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
